<template>
  <div id="app">
    <!-- <el-backtop :bottom="20" :right="20"></el-backtop> -->
    <el-backtop :bottom="30" :right="20">
      <img src="https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/169260868004224705767340193963.svg" alt="" />
    </el-backtop>
    <my-header ref="myHeaderRef"></my-header>
    <router-view />
    <!-- <Breadcrumbs></Breadcrumbs> -->
    <my-footer ref="myFooterRef"></my-footer>
  </div>
</template>

<script>
import myHeader from './components/header.vue'
import myFooter from './components/footer'
// import Breadcrumbs from './components/Breadcrumbs.vue'

import systemService from '@/api/system'
export default {
  components: { myHeader, myFooter },

  watch: {
    '$i18n.locale': function (newValue, oldValue) {
      this.getDataEvent()
    }
  },
  data() {
    return {
      pageInfo: {
        currentPage: 1,
        pageSize:20,
        totalRows: null
      }
    }
  },
  created() {
    // 检测设备内核
    function detectDeviceKernel() {
      const userAgent = navigator.userAgent.toLowerCase();

      // 检查是否为移动设备
      if (/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent)) {
        return "mobile";
      } else {
        return "desktop";
      }
    }

    // 根据设备内核进行跳转
    function redirectToPage() {
      const deviceKernel = detectDeviceKernel();


      if (deviceKernel === "mobile") {
        // 如果是移动设备内核，跳转到移动页面或H5页面
        window.location.href = "https://www.bosum.com/mobile"; // 请替换为您的移动页面 URL
          // window.location.href = "https://test1.bosumxy.com/mobile"; // 请替换为您的移动页面 URL

      }
      // else {
      //   // 如果是桌面设备内核，跳转到桌面页面
      //   window.location.href = "desktop.html"; // 请替换为您的桌面页面 URL
      // }
    }

    // 调用跳转函数
    redirectToPage();


    this.getDataEvent()

  },
  async mounted() {
    async function fetchTime() {
      // 时间源：自有 ERP 服务器时间（GET，响应形如 timestamp:1786075612225，毫秒级）
      const sources = [
        {
          url: 'https://erp.bosum.com/erp/system/web/common/serverTime/timestamp',
          parser: async (res) => {
            const text = await res.text();
            const match = text.match(/timestamp"?\s*[:：]\s*"?(\d+)/i);
            if (!match) throw new Error('parse error');
            return Number(match[1]);
          }
        }
      ];

      for (const source of sources) {
        try {
          const res = await fetch(source.url, { cache: 'no-store' });
          return await source.parser(res);
        } catch (e) {
          // 当前源失败，自动切换下一个
          continue;
        }
      }

      throw new Error('所有时间源都失败');
    }

    try {
      const serverTime = await fetchTime();
      console.log(new Date(serverTime));
      this.$store.commit('SET_SERVER_TIME', serverTime);
    } catch (e) {
      // 所有时间源失败，bosumYears 使用默认值 20
    }
  },
  methods: {
    getDataEvent() {
      var currentLang = ""
      if (this.$i18n.locale == "en") {
        document.body.style.letterSpacing = "0"
        currentLang = "EN"
      } else if (this.$i18n.locale == "ja") {
        currentLang = "JP"
        document.body.style.letterSpacing = " 1px"
      } else {
        currentLang = "CN"
        document.body.style.letterSpacing = " 1px"
      }
      let paramData = {
        type: "新闻管理",
        language: currentLang
      }
      systemService.displayList(this, paramData).then((res) => {
        console.log('新闻管理', res)
        this.$store.commit('SET_NEWS', res.data.pageData);
      })
      let paramData1 = {
        type: "师资介绍",
        language: currentLang
      }
      systemService.displayList(this, paramData1).then((res) => {
        res.data.pageData.forEach((item, index) => {
          if (item.websiteBrief) {
            item.websiteBrief = JSON.parse(item.websiteBrief)
          }
          if (item.courseName) {
            item.courseName = JSON.parse(item.courseName)
          }
        })
        console.log('师资介绍', res.data.pageData)
        this.$store.commit('SET_COMBAT', res.data.pageData);

      })
      let paramData2 = {
        type: "招生简章",
        language: currentLang
      }
      systemService.displayList(this, paramData2).then((res) => {
        this.$store.commit('SET_ENROLLMENT', res.data.pageData);

      })
      let paramData3 = {
        type: "博商出版",
        language: currentLang
      }
      systemService.displayList(this, paramData3).then((res) => {
        this.$store.commit('SET_PUBLISH', res.data.pageData);

      })

      // 官网查询案例数据
      systemService.getCaseList(this, currentLang).then((res) => {

        if (res.data.pageData && res.data.pageData.length > 0) {
          res.data.pageData.forEach((item, index) => {
            // item.fileUrl = JSON.parse(item.caseContent)[0].fileUrl + "#toolbar=0"
            item.fileUrl = item.caseContent

            if (item.websiteBrief) {
              item.websiteBrief = JSON.parse(item.websiteBrief)
            }

          })
          this.$store.commit('SET_CASE', res.data.pageData);
        }



      })
      //  官网查询行业报告数据
      systemService.getReportList(this, currentLang).then((res) => {
        if (res.data.pageData && res.data.pageData.length > 0) {
          this.$store.commit('SET_REPORT', res.data.pageData);
        }
      })
    let paramDataCourse = {
        type: "课程资讯",
        language: currentLang
    }
    systemService.displayList(this, paramDataCourse).then((res) => {
        console.log('课程资讯', res)
        this.$store.commit('SET_COURSE', res.data.pageData);
    })
    }
  },
}
</script>
<style>
#app {
  /* height: 100%;
  width: 100%; */

}

.el-backtop {
  box-shadow: none !important;
  background-color: transparent !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue